import { gql } from '@apollo/client';

export const GET_SAVED_SEARCHES_WITH_NEW_FLYERS = gql`
  query getSavedSearchWithNewFlyers {
    savedSearches: getSavedSearchWithNewFlyers {
      search
      totalFlyers
      totalNewFlyers
    }
  }
`;
